var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"proposal-card d-flex flex-column justify-space-around",style:({
    color: _vm.color,
    backgroundColor: _vm.backgroundColor
  }),attrs:{"rounded":"lg","elevation":"2","href":_vm.link},on:{"click":function($event){$event.preventDefault();return _vm.handleLink.apply(null, arguments)}}},[_c('img',{attrs:{"src":_vm.src,"title":'logo' + _vm.proposal.descr}}),(_vm.proposal.content)?_c('v-card-text',{staticClass:"pre-slide-text",style:({
      color: _vm.color
    }),domProps:{"innerHTML":_vm._s(_vm.proposal.content)}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }